// Vendor imports
const classNames = require('classnames')
const _ = require('lodash')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const LazyImage = require('client-v2/common/components/lazy-image')
const useClientEffect = require('client-v2/common/hooks/client-effect')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('IntoLandingFeedItemCard')

/**
 * This is a constant so that it does not change between renders
 * @type {[]}
 * @readonly
 */

function IntoLandingFeedItemCard(props) {
  const { href, item, user, onClick } = props
  const article = _.get(item, 'article')
  const cardRef = React.useRef()
  const [height, setHeight] = React.useState(0)

  // Hooks

  useClientEffect(
    () => {
      const cardEl = cardRef.current
      const adjustCardHeight = () => setHeight(`${cardEl.clientWidth}px`)
      adjustCardHeight()
      window.addEventListener('resize', adjustCardHeight)
      return () => {
        window.removeEventListener('resize', adjustCardHeight)
      }
    },
    [ cardRef, setHeight ]
  )

  // Render
  return (
    tag('a', {
      ref: cardRef,
      className: classNames(
        props.className,
        bem.block()
      ),
      // Add referral param
      href: href ? href + `?liked_by=${user.username}` : null,
      onClick: href ? onClick : null
    },
      tag('div', {
        className: bem.element('inner'),
        style: { height }
      },
        article && tag(LazyImage, {
          className: bem.element('image'),
          sources: [ article.thumbnail ]
        })
      )
    )
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')
  const ArticleModelRecord = require('client-v2/common/models/article/record')

  IntoLandingFeedItemCard.propTypes = {
    // Values
    className: PropTypes.string,
    href: PropTypes.string,
    item: PropTypes.shape(ArticleModelRecord.propTypes),
    // Callbacks
    onClick: PropTypes.func,
    onFollowClick: PropTypes.func
  }
}

module.exports = IntoLandingFeedItemCard
